import React, { forwardRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';
import { inputFieldClasses } from './Input';
import classNames from '../../utils/classNames';

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
    (
        {
            className = inputFieldClasses,
            rows = 5,
            value,
            onValueChange,
            onChange,
            disabled = false,
            error = false,
            ...props
        },
        ref
    ) => (
        <textarea
            ref={ref}
            className={classNames(className, { 'border-red-500': error })}
            rows={rows}
            defaultValue={value}
            onChange={(e) => {
                if (onChange) onChange(e);
                if (onValueChange) onValueChange(e.target.value);
            }}
            disabled={disabled}
            {...props}
        />
    )
);

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    onValueChange?: (value: string) => void;
    error?: boolean;
}

TextArea.displayName = 'TextArea';

export default TextArea;
